import { render, staticRenderFns } from "./BookingPrestaIssues.vue?vue&type=template&id=b0b807b4&scoped=true"
import script from "./BookingPrestaIssues.vue?vue&type=script&lang=js"
export * from "./BookingPrestaIssues.vue?vue&type=script&lang=js"
import style0 from "./BookingPrestaIssues.vue?vue&type=style&index=0&id=b0b807b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b807b4",
  null
  
)

export default component.exports